import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetBankAccountDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { InvoiceTypeObj } from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface BankAccountSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const bankAccountForGrid = (
  t: TFunction<'administrationLng', 'administrationLng'>,
  bankAccount: GetBankAccountDto,
) => {
  return {
    key: bankAccount.id,
    values: {
      'bankAccount.systemNumber': bankAccount.systemNumber,
      'bankAccount.number': bankAccount.number,
      'company.shortname': bankAccount.company.shortname,
      invoice_type: t(InvoiceTypeObj[bankAccount.invoiceType]),
      'bankAccount.currency': bankAccount.currency,
      'bankAccount.swiftBIC': bankAccount.swiftBIC,
      'bankAccount.bankName': bankAccount.bankName,
      'client.name': bankAccount.client?.name,
    },
    isInactive: !bankAccount.active,
  };
};

export const BankAccountSearch: React.FC<BankAccountSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.sysNumber), property: 'bankAccount.systemNumber' },
    {
      header: t(tk.administration.accountNumber),
      property: 'bankAccount.number',
    },
    { header: t(tk.common.company), property: 'company.shortname' },
    { header: t(tk.administration.invoiceType), property: 'invoice_type' },
    { header: t(tk.common.currency), property: 'bankAccount.currency' },
    { header: t(tk.administration.swift), property: 'bankAccount.swiftBIC' },
    { header: t(tk.administration.bankName), property: 'bankAccount.bankName' },
    { header: t(tk.common.client), property: 'client.name' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="bankAccount.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.administration.noBankAccounts)}
      onRowClick={props.onRowClick}
      withHistory={true}
      refresh={props.refresh}
      withFilterInColumns={true}
    />
  );
};
